( function () {
  'use strict';

  /* ============================================================
     DESKTOP SUBMENUS — Popover API handles open/close/Escape/
     outside-click automatically. We only need:
     1. Close siblings when a new submenu opens
     2. Close on scroll (currently disabled)
  ============================================================ */

  function throttle(func, wait) {
    let timeout;
    return function () {
      if (timeout) return;
      timeout = setTimeout(() => { func.apply(this, arguments); timeout = undefined; }, wait);
    };
  }

  const desktopNav = document.getElementById('js-desktop-nav');

  if (desktopNav) {
    const submenus = () => desktopNav.querySelectorAll('.sub-menu_0[popover]');

    // Sync aria-expanded on the trigger button; close siblings when opening
    desktopNav.addEventListener('toggle', (e) => {
      const btn = desktopNav.querySelector(`[popovertarget="${e.target.id}"]`);
      if (btn) btn.setAttribute('aria-expanded', e.newState === 'open');
      if (e.newState !== 'open') return;
      submenus().forEach(sm => {
        if (sm !== e.target) sm.hidePopover();
      });
    }, true); // capture to get the event before popover finishes

    /* Close on scroll
    let yPos = window.scrollY;
    const closeOnScroll = throttle(() => {
      if (Math.abs(yPos - window.scrollY) > 30) {
        submenus().forEach(sm => {
          try { sm.hidePopover(); } catch (_) {}
        });
      }
      yPos = window.scrollY;
    }, 100);
    window.addEventListener('scroll', closeOnScroll);
    */
  }

  /* ============================================================
     MOBILE SUBMENUS — accordion toggle (no popover on mobile)
  ============================================================ */

  const mobileNav = document.getElementById('js-mobile-nav');

  if (mobileNav) {
    mobileNav.querySelectorAll('.menu-item-has-children').forEach(item => {
      const link = item.querySelector(':scope > a');
      if (!link) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'interactive';
      button.innerHTML = link.innerHTML.trim();
      button.setAttribute('aria-expanded', 'false');
      link.replaceWith(button);

      const submenu = item.querySelector('.sub-menu_0');
      button.addEventListener('click', () => {
        const isOpen = item.classList.toggle('is-open');
        button.setAttribute('aria-expanded', isOpen);
        // close siblings
        item.closest('ul').querySelectorAll(':scope > .menu-item-has-children').forEach(sib => {
          if (sib !== item) {
            sib.classList.remove('is-open');
            sib.querySelector('button')?.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
  }

  /* ============================================================
     MOBILE DRAWER — popover toggle
  ============================================================ */

  const mobileDrawer    = document.getElementById('js-mobile-drawer');
  const mobileNavToggle = document.getElementById('mobile-nav-toggle');

  if (mobileDrawer && mobileNavToggle) {
    const defaultBtnText = mobileNavToggle.innerText;

    mobileDrawer.addEventListener('toggle', () => {
      const open = mobileNavToggle.getAttribute('aria-expanded') === 'true';
      mobileNavToggle.innerText = open ? defaultBtnText : 'Close';
      mobileNavToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  /* ============================================================
     STICKY HEADER — IntersectionObserver
  ============================================================ */

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      document.body.classList.toggle('body-scrolled', entries[0].boundingClientRect.y < 0);
    });
    const sentinel = document.querySelector('#scroll-observer');
    if (sentinel) observer.observe(sentinel);
  }

  /* ============================================================
     EXTERNAL LINKS
  ============================================================ */

  function markExternalLinks() {
    const internal = new RegExp(location.host.replace('www.', ''), 'i');
    const main = document.querySelector('main');
    (main ?? document).querySelectorAll('a[href]').forEach(link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || /^(mailto:|tel:|javascript:)/i.test(href)) return;
      try {
        const url = new URL(href, window.location.origin);
        if (!internal.test(url.host)) {
          link.setAttribute('target', '_blank');
          link.setAttribute('rel', 'noopener noreferrer');
        }
      } catch (_) {}
    });
  }
  markExternalLinks();

  document.querySelectorAll('a[target="_blank"]').forEach(link => {
    if (!link.querySelector('.screen-reader-text')) {
      link.insertAdjacentHTML('beforeend', '<span class="screen-reader-text">(opens in a new tab)</span>');
    }
  });

  /* ============================================================
    NAV SEARCH LINK 
    Change the search link in the navigation from a link to 
    a button that opens the search dialog
  ============================================================ */

  function searchLinkToButton() {
    const navSearchLink = document.querySelector('.js-nav-search a');
    if (!navSearchLink) return;

    const popover     = document.getElementById('js-search-dialog');
    const closeButton = document.getElementById('js-close-search');

    const openButton = document.createElement('button');
    openButton.setAttribute('type', 'button');
    openButton.setAttribute('popovertarget', 'js-nav-search');
    openButton.setAttribute('class', 'interactive');
    openButton.innerHTML = `<span class="screen-reader-text">${navSearchLink.innerHTML}</span>`;
    navSearchLink.parentNode.replaceChild(openButton, navSearchLink);

    openButton.addEventListener('click', () => popover.showModal());
    closeButton.addEventListener('click', () => popover.close());
    popover.addEventListener('click', e => {
      e.stopPropagation();
      if (e.target.tagName === 'DIALOG') popover.close();
    });
  }
  searchLinkToButton();

  /* ============================================================
    PARTNER POPOP FORM
    Change any links to the partner with us form to buttons that open
    the partner with us form dialog.
  ============================================================ */

  function partnerLinksToButtons() {
    const partnerLinks = document.querySelectorAll('a[href*="partner-with-us/#partner-form"]');
    if (!partnerLinks.length) return;

    const popover     = document.getElementById('js-partner-dialog');
    const closeButton = document.getElementById('js-close-partner');
    if (!popover || !closeButton) return;

    const buttonTemplate = document.createElement('button');
    buttonTemplate.type = 'button';
    buttonTemplate.setAttribute('popovertarget', 'js-nav-partner');
    
    partnerLinks.forEach(link => {
      const openButton = buttonTemplate.cloneNode(true);
      openButton.className = link.className;
      openButton.innerHTML = link.innerHTML;
      link.parentNode.replaceChild(openButton, link);
      openButton.addEventListener('click', () => {
        if(typeof window.cwLoadHubSpotForms === 'function'){
          window.cwLoadHubSpotForms();
        }
        popover.showModal();
      })
    });

    closeButton.addEventListener('click', () => popover.close());
    popover.addEventListener('click', e => {
      e.stopPropagation();
      if (e.target.tagName === 'DIALOG') popover.close();
    });
  }
  partnerLinksToButtons();

}() );
